import { render, staticRenderFns } from "./VendorQuality.vue?vue&type=template&id=5d943da2"
import script from "./VendorQuality.vue?vue&type=script&lang=js"
export * from "./VendorQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports